import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {OkCancelController} from '../../../core/dialog/OkCancelController';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import ErrorService from '../../../core/errors/service/ErrorService';
import AnlaufstelleRS from '../../../core/service/AnlaufstelleRS.rest';
import PasswordStrengthService from '../../../core/service/PasswordStrengthService';
import RoleUtilService from '../../../core/service/RoleUtilService';
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import AbstractModelManagerController from '../../../gesuch/component/abstractModelManagerController';
import {getTSAnlaufstelleTypeValues, TSAnlaufstelleType} from '../../../models/enums/TSAnlaufstelleType';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import {getKantonCodeList, TSKantonCode} from '../../../models/enums/TSKantonCode';
import {TSSprache} from '../../../models/enums/TSSprache';
import TSAnlaufstelleWithUsers from '../../../models/TSAnlaufstelleWithUsers';
import TSBenutzer from '../../../models/TSBenutzer';
import TSGemeinde from '../../../models/TSGemeinde';
import DVBernUtil from '../../../utils/DVBernUtil';
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;

let template = require('./anlaufstelleView.html');
let okCancelTemplate = require('../../../core/dialog/okCancelTemplate.html');
require('./anlaufstelleView.scss');

export class AnlaufstelleViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = AnlaufstelleViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        anlaufstelle: '<'
    };
}

export class AnlaufstelleViewController extends AbstractModelManagerController<TSAnlaufstelleWithUsers> {

    anlaufstelle: TSAnlaufstelleWithUsers;
    form: IFormController;
    gemeindeToAdd: TSGemeinde | undefined;
    sachbearbeiterToAdd: TSBenutzer = new TSBenutzer();
    sachbearbeiterList: Array<TSBenutzer>;
    schaetzerToAdd: TSBenutzer = new TSBenutzer();
    schaetzerList: Array<TSBenutzer>;
    createNew: boolean = true;
    disableVerwalterselection: boolean;
    doctype: TSDocumentType = TSDocumentType.ANLAUFSTELLE_DOC;

    static $inject = ['DVBernUtil', '$q', '$scope', '$log', '$state', 'AnlaufstelleRS', 'PasswordStrengthService',
        'ErrorService', 'SchadenfallModelManager', 'RoleUtilService', 'AuthServiceRS', 'DvDialog', 'CONSTANTS'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil,
                private $q: IQService,
                $scope: IScope, private $log: ILogService,
                private $state: IStateService, private anlaufstelleRS: AnlaufstelleRS,
                private passwordStrengthService: PasswordStrengthService,
                private errorService: ErrorService, schadenfallModelManager: SchadenfallModelManager,
                private roleUtilService: RoleUtilService, private authService: AuthServiceRS,
                private dvDialog: DvDialog,
                private CONSTANTS: any) {
        super(schadenfallModelManager, $scope, $state.current.name);
        // super();
    }

    $onInit() {
        super.$onInit();
        if (this.anlaufstelle.id) {
            this.createNew = false;
        }
        if (this.authService.isOneOfRoles(this.roleUtilService.getAdministratorRoles()) || this.anlaufstelle.verwalter === undefined) {
            this.disableVerwalterselection = false;
        } else {
            this.disableVerwalterselection = true;
        }
        this.initialModel = this.anlaufstelle;
        this.model = angular.copy(this.anlaufstelle);
    }

    public getTSAnlaufstelleTypeValues(): Array<TSAnlaufstelleType> {
        return getTSAnlaufstelleTypeValues();
    }

    public save() {
        this.cleanUnnecessaryFields();
        if (this.isModelValid() && this.model) {
            this.anlaufstelleRS.createOrUpdate(this.model).then((response: TSAnlaufstelleWithUsers) => {
                this.$state.go('anlaufstelleverwaltung');
            });
        }
        this.$log.debug('Form was not valid');
    }

    private cleanUnnecessaryFields() {
        if (this.isKantonType()) {
            this.model.gemeinden = []
        } else {
            this.model.kanton = undefined; //wenn wir den Kanton nicht brauchen nullen wir ihn
        }

        // entfernen von moeglicherweise invaliden emails fuer schaeter und sachbearbeiter
        this.sachbearbeiterToAdd = new TSBenutzer();
        this.schaetzerToAdd = new TSBenutzer();
    }

    /**
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    public isModelValid(): boolean {
        if (!this.form.$valid) {
            DVBernUtil.focusFirstInvalidInput()
        }
        return this.form.$valid;
    }

    public addGemeinde() {
        if (this.gemeindeToAdd) {
            this.model.gemeinden.push(this.gemeindeToAdd);
        }
        this.gemeindeToAdd = undefined;
    }

    deleteClicked(gemeindeToDelete: TSGemeinde, event: any) {
        let index = DVBernUtil.getIndexOfElementwithID(gemeindeToDelete, this.model.gemeinden);
        if (index > -1) {
            this.model.gemeinden.splice(index, 1);
        }
    }

    public isKantonType(): boolean {
        return this.model.anlaufstelleType !== undefined && this.model.anlaufstelleType === TSAnlaufstelleType.KANTON;
    }

    public cancel() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('anlaufstelleverwaltung');
    }

    public kantonList(): Array<TSKantonCode> {
        return getKantonCodeList()
    }

    public translateKanton(kantonCode: TSKantonCode): string {
        return TSKantonCode[kantonCode];
    }

    private getSchaetzer(): Array<TSBenutzer> {
        return this.getModel().schaetzer;
    }

    private setSchaetzer(collectionOfSB: Array<TSBenutzer>) {
        this.getModel().schaetzer = collectionOfSB;
    }

    private getSachbearbeiter(): Array<TSBenutzer> {
        return this.getModel().sachbearbeiter;
    }

    private setSachbearbeiter(collectionOfSB: Array<TSBenutzer>) {
        this.getModel().sachbearbeiter = collectionOfSB;
    }

    public addSchaetzer() {
        if (this.form.schaetzerEmail.$invalid ||
            !this.schaetzerToAdd || !this.schaetzerToAdd.email
            || this.alreadyPresent(this.getSchaetzer(), this.schaetzerToAdd.email)) {
            return;
        }
        this.schaetzerToAdd.korrespondenzsprache = this.anlaufstelle.verwalter ? this.anlaufstelle.verwalter.korrespondenzsprache : TSSprache.DEUTSCH;
        this.getSchaetzer().push(this.schaetzerToAdd);
        this.schaetzerToAdd = new TSBenutzer();
    }

    public addSachbearbeiter() {
        if (this.form.sachbearbeiterEmail.$invalid
            || !this.sachbearbeiterToAdd || !this.sachbearbeiterToAdd.email
            || this.alreadyPresent(this.getSachbearbeiter(), this.sachbearbeiterToAdd.email)) {
            return;
        }

        this.sachbearbeiterToAdd.korrespondenzsprache = this.anlaufstelle.verwalter ? this.anlaufstelle.verwalter.korrespondenzsprache : TSSprache.DEUTSCH;
        this.getSachbearbeiter().push(this.sachbearbeiterToAdd);
        this.sachbearbeiterToAdd = new TSBenutzer();
    }

    public removeSchaetzer(benutzer: TSBenutzer, event: any) {
        if (benutzer) {
            let arrWithoutEle = this.getSchaetzer().filter(currentBen => currentBen !== benutzer);
            this.setSchaetzer(arrWithoutEle)
        }

    }

    public removeSachbearbeiter(benutzer: TSBenutzer, event: any) {
        if (benutzer) {
            let arrWithoutEle = this.getSachbearbeiter().filter(currentBen => currentBen !== benutzer);
            this.setSachbearbeiter(arrWithoutEle)

        }

    }

    public enableVerwalterselection() {
        let text = 'CONFIRM_VERWALTERCHANGE';
        this.dvDialog.showDialog(okCancelTemplate, OkCancelController,
            {text: text})
            .then(() => {   //User confirmed removal
                this.disableVerwalterselection = false;
            })
            .catch(() => {
            });

    }

    private alreadyPresent(sachbearbeiter: Array<TSBenutzer>, email: string): boolean {
        return sachbearbeiter.find(value => value.email === email) !== undefined;
    }
}



// WEBPACK FOOTER //
// ./src/app/anlaufstelleverwaltung/component/anlaufstelleView/anlaufstelleView.ts